<template>
    <div class="bg-gray-800 text-white shadow-lg rounded-lg w-full p-8">
        <h2 class="text-2xl mb-6">Reset Password</h2>
        <form @submit.prevent="resetPassword">
            <div class="form-control mb-4">
                <label for="newPassword" class="label">New Password</label>
                <div class="flex items-center border border-gray-600 rounded-lg bg-gray-700 px-3 py-2">
                    <i class="bi bi-lock text-gray-400 text-lg mr-2"></i>
                    <input type="password" id="newPassword" v-model="newPassword" placeholder="Enter your new password"
                        class="bg-transparent text-white w-full border-0 focus:ring-0 focus:outline-none" required />
                </div>
            </div>
            <div class="form-control mb-4">
                <label for="confirmPassword" class="label">Confirm Password</label>
                <div class="flex items-center border border-gray-600 rounded-lg bg-gray-700 px-3 py-2">
                    <i class="bi bi-lock text-gray-400 text-lg mr-2"></i>
                    <input type="password" id="confirmPassword" v-model="confirmPassword" placeholder="Confirm your new password"
                        class="bg-transparent text-white w-full border-0 focus:ring-0 focus:outline-none" required />
                </div>
                <p v-if="passwordMismatch" class="text-red-500 text-sm mt-2">Passwords must match.</p>
            </div>
            <button type="submit" class="bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg w-full mt-4">Reset Password</button>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        apiUrl: String,
        email: String,
        accessToken: String,
        idToken: String,
        sessionToken: String,
        refreshToken: String
    },
    data() {
        return {
            newPassword: '',
            confirmPassword: '',
            passwordMismatch: false
        };
    },
    methods: {
        resetPassword() {
            if (this.newPassword !== this.confirmPassword) {
                this.passwordMismatch = true;
                return;
            }

            const url = `${this.apiUrl}/user/password/update`;
            const data = {
                password: this.newPassword,
                session: this.sessionToken,
                username: this.email
            };

            axios.post(url, data)
            .then(response => {
                this.$emit("set-tokens", response.data.access_token, response.data.id_token, response.data.refresh_token);
            })
            .catch(error => {
                console.error(error);
            });
        }
    },
    watch: {
        newPassword() { this.passwordMismatch = false; },
        confirmPassword() { this.passwordMismatch = false; }
    }
};
</script>
